/* eslint-disable no-console */
import type { ScopeContext } from "@sentry/types";

const consoleMethodByLevel = {
  debug: console.debug.bind(console),
  log: console.log.bind(console),
  warning: console.warn.bind(console),
  error: console.error.bind(console),
  fatal: console.error.bind(console),
} as const;

export type LogLevel = "debug" | "log" | "warning" | "error" | "fatal";

const LOG_LEVEL_ORDERS = {
  debug: 0,
  log: 1,
  warning: 2,
  error: 3,
  fatal: 4,
};

export type Context = Partial<Pick<ScopeContext, "tags" | "extra">>;

 
export class Logger {
  public static logLevel: LogLevel = "error";

  private static base(
    message: string | Error,
    level: LogLevel,
    context?: Context,
  ) {
    if (LOG_LEVEL_ORDERS[level] >= LOG_LEVEL_ORDERS[this.logLevel]) {
      const logForConsole: unknown[] = ["[BluxClient]", message];

      if (context?.extra) {
        logForConsole.push(context.extra);
      }
      if (context?.tags) {
        logForConsole.push(context.tags);
      }

      consoleMethodByLevel[level]?.(...logForConsole);
    }
  }
  public static debug(message: string | Error, context?: Context) {
    this.base(message, "debug", context);
  }
  public static log(message: string | Error, context?: Context) {
    this.base(message, "log", context);
  }
  public static warning(message: string | Error, context?: Context) {
    this.base(message, "warning", context);
  }
  public static error(message: string | Error, context?: Context) {
    this.base(message, "error", context);
  }
  public static fatal(message: string | Error, context?: Context) {
    this.base(message, "fatal", context);
  }

  public static setLevel(level: LogLevel) {
    this.logLevel = level;
  }
}
